import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { getShortDateString } from 'dpl/shared/utils/date';
import RichText from 'dpl/prismic/components/RichText';
import { getArticlePath } from 'dpl/prismic/utils';
import { ArticlePropTypes } from 'dpl/prismic/utils/customPropTypes';
import { ARTICLE_TYPES } from 'dpl/prismic/article/utils/constants';
import PodcastEmbed from 'dpl/prismic/components/PodcastEmbed';

export default function ArticlePreviewsList({ sliceData }) {
  const articlesWithData = sliceData.items.filter(item => item.article.data);

  if (articlesWithData.length === 0) {
    return null;
  }

  return (
    <div className="PrismicArticlePreviewsList container">
      <div className="row">
        <div className="col-lg-8 center">
          <ol>
            {articlesWithData.map(({ article }, idx) => (
              <li
                className={classnames('pv8', {
                  'bb b--light-gray': idx < articlesWithData.length - 1
                })}
                key={idx}
              >
                <a href={getArticlePath(article)}>
                  {article.data.title && article.data.title.length > 0 && (
                    <p className="mb2 f4 f5-lg fw-medium">
                      {RichText.asText(article.data.title)}
                    </p>
                  )}
                  {article.data.display_date && (
                    <p className="mb2 mb4-lg f2 f3-lg black-50">
                      {getShortDateString(new Date(article.data.display_date))}
                    </p>
                  )}
                  {article.data.seo_description && (
                    <p>{article.data.seo_description}</p>
                  )}
                  {article.data.article_type === ARTICLE_TYPES.PODCAST &&
                    article.data.podcast_embed &&
                    (article.data.podcast_embed.url ||
                      article.data.podcast_embed.embed_url) && (
                      <div className="mt6">
                        <PodcastEmbed
                          url={
                            article.data.podcast_embed.url ||
                            article.data.podcast_embed.embed_url
                          }
                        />
                      </div>
                    )}
                </a>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
}

ArticlePreviewsList.propTypes = {
  sliceData: PropTypes.shape({
    items: PropTypes.arrayOf(ArticlePropTypes).isRequired
  }).isRequired
};
